<template>
    <div>
        <route-view></route-view>
    </div>
</template>

<script>

    import RouteView from "@/components/layouts/RouteView";


    export default {
        name: "BasicLayout",
        components: {
            RouteView
        },
    }
</script>

<style scoped lang="less">

</style>
